import React, { Component } from 'react';
import './FilterAdminRecords.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getAdminSessions,
  getSessionCreators,
  resetSessionCreators
} from '../../../../Reducks/AdminSessions/AdminSessionsActions';
import {
  getAdminWebinars,
  getWebinarCreators,
  resetWebinarCreators
} from '../../../../Reducks/AdminWebinars/AdminWebinarsActions';
import WebinarsTable from '../../../Admin/Webinars/Table/WebinarsTable';
import RangeFilter from '../../../Sessions/Filters/SessionsRangeFilter';
import { RecordingSource, CREATORS_PAGE_COUNT, ReportType } from '../../../../Utils/Constants';
import SessionsDateRangeSelector from '../../../Sessions/Filters/SessionsDateRangeSelector';
import WebinarsDateRangeSelector from '../../../Webinars/Filters/WebinarsDateRangeSelector';
import { GENERATE_REPORT } from '../../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import SessionsTable from '../../../Admin/Sessions/Table/SessionsTable';
import OrganizerFilter from '../../../Admin/Filters/OrganizerFilter';
import RecordingsDateRangeSelector from '../../../Recordings/Filters/RecordingsDateRangeSelector';
import { actions as recordingsActions } from '../../../../Reducks/AdminRecordings';
import RecordingsTable from '../../../Admin/Recordings/Table/RecordingsTable';

class FilterRecords extends Component {
  static propTypes = {
    reportType: PropTypes.string,
    navigateToReportTypeRow: PropTypes.any,
    isBig: PropTypes.bool.isRequired,
    warningMessage: PropTypes.any
  };
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  render() {
    const { reportType, navigateToReportTypeRow, isBig, warningMessage } = this.props;
    return (
      <div className="filterRecords">
        {navigateToReportTypeRow}
        {!isBig && warningMessage && <div>{warningMessage}</div>}
        <div>{this.getTableForType(reportType)}</div>
      </div>
    );
  }

  getTableForType = reportType => {
    const mixpanelData = {
      action: GENERATE_REPORT,
      reportType: reportType
    };
    switch (reportType) {
      case ReportType.WEBINAR_ATTENDEE_REPORT:
        return (
          <SessionsComponentsContainer
            includeEngagementColumns={false}
            isBig={this.props.isBig}
            mixpanelData={mixpanelData}
          />
        );
      case ReportType.WEBINAR_REGISTRATION_REPORT:
        return <WebinarsComponentsContainer isBig={this.props.isBig} mixpanelData={mixpanelData} />;
      case ReportType.WEBINAR_RECORDING_REPORT:
        return <RecordingsComponentsContainer isBig={this.props.isBig} mixpanelData={mixpanelData} />;
      default:
        return null;
    }
  };
}

export default FilterRecords;

export class SessionsComponents extends Component {
  static propTypes = {
    includeEngagementColumns: PropTypes.bool.isRequired,
    reduced_sessions: PropTypes.object,
    isBig: PropTypes.bool.isRequired,
    accountKey: PropTypes.string,
    resetSessionCreators: PropTypes.func,
    getSessionCreators: PropTypes.func,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    })
  };
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  getOrganizerFilterSessions = creators => {
    const { accountKey, getSessions, reduced_sessions } = this.props;
    const { fromTime, toTime, registrantRange, attendeeRange } = reduced_sessions.filter;
    getSessions(accountKey, fromTime, toTime, creators, registrantRange, attendeeRange);
  };

  getFilteredSessionsByCount = filterOptions => {
    const { accountKey, getSessions, reduced_sessions } = this.props;
    const { registrantRange, attendeeRange } = filterOptions;
    const { fromTime, toTime, creators } = reduced_sessions.filter;
    getSessions(accountKey, fromTime, toTime, creators, registrantRange, attendeeRange);
  };

  getDateFilterSessions = (fromTime, toTime) => {
    const { accountKey, getSessions, reduced_sessions, getSessionCreators } = this.props;
    const { creators, registrantRange, attendeeRange } = reduced_sessions.filter;
    getSessions(accountKey, fromTime, toTime, creators, registrantRange, attendeeRange);
    getSessionCreators(accountKey, fromTime, toTime, 0, null, CREATORS_PAGE_COUNT, true);
  };

  getFilteredSessionsByCount = filterOptions => {
    const { accountKey, getSessions, reduced_sessions } = this.props;
    const { registrantRange, attendeeRange } = filterOptions;
    const { fromTime, toTime, creators } = reduced_sessions.filter;
    getSessions(accountKey, fromTime, toTime, creators, registrantRange, attendeeRange);
  };

  render() {
    const {
      isBig,
      mixpanelData,
      includeEngagementColumns,
      reduced_sessions,
      accountKey,
      getSessionCreators,
      resetSessionCreators
    } = this.props;
    const { t } = this.context;
    const { filter, creators, creatorsFetching } = reduced_sessions;
    return (
      <div className="reportTypeComponents spreadVerticalItems-12">
        {isBig && (
          <div>
            <div className="d-flex justify-content-between align-items-center spreadHorizontalItems-8 ">
              <div className="events-timer">{t('generateReport.wizard.generateEvents')}</div>
              <div className="d-flex spreadHorizontalItems-8">
                <div>
                  <OrganizerFilter
                    isBig={true}
                    uniqueId={'sessionsOrganizerFilterContainer'}
                    getData={this.getOrganizerFilterSessions}
                    getCreators={getSessionCreators}
                    resetCreators={resetSessionCreators}
                    creators={creators.creators}
                    creatorsFetching={creatorsFetching}
                    filteredCreators={filter.creators}
                    fromTime={filter.fromTime}
                    toTime={filter.toTime}
                    nextPage={creators.nextPage}
                    accountKey={accountKey}
                    page={creators.page}
                    mixpanelData={mixpanelData}
                  />
                </div>
                <div>
                  <SessionsDateRangeSelector
                    uniqueId={'sessionsDateRangeSelectorInGenerateReportWizard'}
                    mixpanelData={mixpanelData}
                    isBig={true}
                    reduced_sessions={reduced_sessions}
                    getSessions={this.getDateFilterSessions}
                  />
                </div>
                <div className={'ve-registrant-range-filter'}>
                  <RangeFilter
                    uniqueId={'sessionsRangeFilterInGenerateReportWizard'}
                    isBig={true}
                    isAdmin={true}
                    mixpanelData={mixpanelData}
                    reduced_sessions={reduced_sessions}
                    filterSessionsByCount={this.getFilteredSessionsByCount}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <SessionsTable
          uniqueId={'sessionsTableInGenerateReports'}
          isBig={isBig}
          sessionData={reduced_sessions.filterReportSessions}
          includeEngagementColumns={includeEngagementColumns}
          focusedSessionKeyInTable={null}
          focusSessionInChart={() => {}}
          mixpanelData={mixpanelData}
        />
      </div>
    );
  }
}

export const SessionsComponentsContainer = connect(
  state => ({
    reduced_sessions: state.reduced_admin_sessions,
    accountKey: state.reduced_user.user.accountKey
  }),
  {
    getSessions: getAdminSessions,
    getSessionCreators,
    resetSessionCreators
  }
)(SessionsComponents);

export class WebinarsComponents extends Component {
  static propTypes = {
    reduced_webinars: PropTypes.object,
    isBig: PropTypes.bool,
    accountKey: PropTypes.string,
    resetWebinarCreators: PropTypes.func,
    getWebinarCreators: PropTypes.func,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    })
  };
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  getOrganizerFilterWebinars = creators => {
    const { accountKey, getWebinars, reduced_webinars } = this.props;
    const { filter } = reduced_webinars;
    getWebinars(accountKey, filter.fromTime, filter.toTime, creators);
  };

  getDateFilterWebinars = (fromTime, toTime) => {
    const { accountKey, getWebinars, reduced_webinars, getWebinarCreators } = this.props;
    const { filter } = reduced_webinars;
    getWebinars(accountKey, fromTime, toTime, filter.creators);
    getWebinarCreators(accountKey, fromTime, toTime, 0, null, CREATORS_PAGE_COUNT, true);
  };

  render() {
    const { isBig, mixpanelData, reduced_webinars, accountKey, getWebinarCreators, resetWebinarCreators } = this.props;
    const { filter, creators, creatorsFetching } = reduced_webinars;
    const { t } = this.context;
    return (
      <div className="reportTypeComponents spreadVerticalItems-12">
        {isBig && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="events-timer">{t('generateReport.wizard.generateEvents')}</div>
            <div className="d-flex justify-content-between align-items-center spreadHorizontalItems-8">
              <OrganizerFilter
                isBig={true}
                uniqueId={'webinarsOrganizerFilterContainer'}
                getData={this.getOrganizerFilterWebinars}
                getCreators={getWebinarCreators}
                resetCreators={resetWebinarCreators}
                creators={creators.creators}
                creatorsFetching={creatorsFetching}
                filteredCreators={filter.creators}
                fromTime={filter.fromTime}
                toTime={filter.toTime}
                nextPage={creators.nextPage}
                accountKey={accountKey}
                page={creators.page}
                mixpanelData={mixpanelData}
              />
              <WebinarsDateRangeSelector
                uniqueId={'webinarsDateRangeSelectorInGenerateReportWizard'}
                isBig={true}
                reduced_webinars={reduced_webinars}
                getWebinars={this.getDateFilterWebinars}
                mixpanelData={mixpanelData}
              />
            </div>
          </div>
        )}
        <WebinarsTable mixpanelData={mixpanelData} isBig={isBig} uniqueId={'webinarsTableInGenerateReports'} />
      </div>
    );
  }
}

export const WebinarsComponentsContainer = connect(
  state => ({
    reduced_webinars: state.reduced_admin_webinars,
    accountKey: state.reduced_user.user.accountKey
  }),
  {
    getWebinars: getAdminWebinars,
    getWebinarCreators,
    resetWebinarCreators
  }
)(WebinarsComponents);

export class RecordingsComponents extends Component {
  static propTypes = {
    reduced_recordings: PropTypes.object,
    isBig: PropTypes.bool,
    filterRecordings: PropTypes.func,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    })
  };
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  getOrganizerFilterRecordings = creators => {
    const { accountKey, getRecordings, reduced_recordings } = this.props;
    console.log(this.props);
    const { filter } = reduced_recordings;
    getRecordings(accountKey, filter.fromTime, filter.toTime, creators);
  };

  getDateFilterRecordings = (fromTime, toTime) => {
    const { accountKey, getRecordings, reduced_recordings, getRecordingCreators } = this.props;
    const { filter } = reduced_recordings;
    getRecordings(accountKey, fromTime, toTime, filter.creators);
    getRecordingCreators(accountKey, fromTime, toTime, 0, null, CREATORS_PAGE_COUNT, true);
  };

  render() {
    const {
      isBig,
      mixpanelData,
      reduced_recordings,
      accountKey,
      getRecordingCreators,
      resetRecordingCreators
    } = this.props;
    const { filter, creators, creatorsFetching } = reduced_recordings;
    const { t } = this.context;
    return (
      <div className="reportTypeComponents spreadVerticalItems-12">
        {isBig && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="events-timer">{t('generateReport.wizard.generateEvents')}</div>
            <div className="d-flex justify-content-between align-items-center spreadHorizontalItems-8">
              <OrganizerFilter
                isBig={true}
                uniqueId={'webinarsOrganizerFilterContainer'}
                getData={this.getOrganizerFilterRecordings}
                getCreators={getRecordingCreators}
                resetCreators={resetRecordingCreators}
                creators={creators.creators}
                creatorsFetching={creatorsFetching}
                filteredCreators={filter.creators}
                fromTime={filter.fromTime}
                toTime={filter.toTime}
                nextPage={creators.nextPage}
                accountKey={accountKey}
                page={creators.page}
                mixpanelData={mixpanelData}
              />
              <RecordingsDateRangeSelector
                uniqueId={'recordingsDateRangeSelectorInGenerateReportWizard'}
                isBig={true}
                reduced_recordings={reduced_recordings}
                getRecordings={this.getDateFilterRecordings}
                mixpanelData={mixpanelData}
              />
            </div>
          </div>
        )}
        <RecordingsTable
          isBig={isBig}
          uniqueId={'recordingsTableInReports'}
          recordingsData={reduced_recordings.recordings}
          reportSource={[RecordingSource.G2W]}
          mixpanelData={mixpanelData}
        />
      </div>
    );
  }
}

export const RecordingsComponentsContainer = connect(
  state => ({
    reduced_recordings: state.reduced_admin_recordings,
    accountKey: state.reduced_user.user.accountKey
  }),
  {
    getRecordings: recordingsActions.getAdminRecordings,
    getRecordingCreators: recordingsActions.getRecordingCreators,
    resetRecordingCreators: recordingsActions.resetRecordingCreators
  }
)(RecordingsComponents);



// WEBPACK FOOTER //
// ./src/GoToWebinar/GenerateReport/AdminWizard/Steps/FilterAdminRecords.js